import { useState, useEffect } from "react";
import api from "../utils/api"; // Your central axios/fetch API instance

export function useNotificationCheck(isLoggedIn, intervalMs = 120000) { // Default to 2 minutes
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    // Guard clause: If the user isn't authenticated, don't ping the database
    if (!isLoggedIn) {
      setHasUnread(false);
      return;
    }

    const checkStatus = async () => {
      try {
        const res = await api.get("/notifications/unread-check");
        // Maps directly to the { hasUnread: true/false } payload from your Express router
        setHasUnread(res.data.hasUnread); 
      } catch (err) {
        console.error("Notification unread status ping failed:", err);
      }
    };

    // Execute immediately on mount
    checkStatus();

    // Set up the background interval loop
    const timer = setInterval(checkStatus, intervalMs);

    // Clean up tracking handles automatically if user logs out or leaves the page
    return () => clearInterval(timer);
  }, [isLoggedIn, intervalMs]);

  return [hasUnread, setHasUnread];
}